import axios from "axios";
import { createOrder_stripe } from "../utils/Constant";

/**
 * Build JSON body for POST /createOrder_stripe
 * @see https://panel.whitelabelmd.com/nextvial/api/createOrder_stripe
 */
export function buildStripeOrderPayload(paymentToken, ctx, productId) {
  const billingSame = ctx.sameAsShipping;

  return {
    email: ctx.email,
    first_name: ctx.firstName,
    last_name: ctx.lastName,
    phone: ctx.phoneNumber || "",
    address: ctx.address,
    city_name: ctx.city,
    state_name: ctx.getselectedStateCode?.state_code || "",
    zip_code: ctx.postalCode,
    start_url:
      typeof window !== "undefined" ? window.location.href : ctx.start_url || "",
    payment_token: paymentToken,
    product_id: parseInt(String(productId), 10),
    address2: ctx.aptSuite || "",
    billing_address: billingSame ? ctx.address : ctx.address2,
    billing_address2: "",
    billing_city_name: billingSame ? ctx.city : ctx.city2,
    billing_state_name: billingSame
      ? ctx.getselectedStateCode?.state_code || ""
      : ctx.getselectedStateCode2?.state_code || "",
    billing_zip_code: billingSame ? ctx.postalCode : ctx.postalCode2,
    billingSameAsShipping: billingSame ? "YES" : "NO",
    promo_codes: ctx.appliedDiscount || null,
  };
}

export async function postStripeOrder(paymentToken, ctx, productId) {
  const body = buildStripeOrderPayload(paymentToken, ctx, productId);
  return axios.post(createOrder_stripe, body, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export function aggregateStripeOrderResponses(responses) {
  const successOrders = [];
  const failedOrders = [];
  let message = "";

  for (const response of responses) {
    const data = response?.data || {};
    message = data.message || message;

    if (Array.isArray(data.success_orders)) {
      successOrders.push(...data.success_orders.map(String));
    } else if (data.status == 1 && data.order_id) {
      successOrders.push(String(data.order_id));
    }

    if (Array.isArray(data.failed_orders)) {
      failedOrders.push(...data.failed_orders.map(String));
    }
  }

  return { successOrders, failedOrders, message };
}
